export const USER_COLLECTION = 'users'
export const BATCH_COLLECTION = 'batches'
export const ITEM_COLLECTION = 'items'
export const WORKFLOW_COLLECTION = 'workflows'